import cx from 'classnames';
import React from 'react';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';

interface Props {
  isActive?: boolean;
  className?: string;
}

const StyledRadioButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  padding: 0px;
  background-color: ${({ theme }) => theme.components.radioButton.backgroundColor};
  border-radius: ${({ theme }) => theme.components.radioButton.borderRadius}px;
  border: ${({ theme }) => `${theme.components.radioButton.border.width}px solid ${theme.components.radioButton.border.color}`};

  &.checked {
    background-color: ${({ theme }) => theme.components.radioButton.checked.backgroundColor};
    border-color: ${({ theme }) => theme.components.radioButton.checked.borderColor};
  }
`;

const StyledDiv = styled.div`
  &.checked {
    width: 11px;
    height: 11px;
    border-radius: ${({ theme }) => theme.components.radioButton.container.checked.borderRadius}px;
    background-color: ${({ theme }) => theme.components.radioButton.container.checked.backgroundColor};
  }
`;

const RadioButton: React.FC<Props> = ({ isActive = false, className }) => (
  <StyledRadioButton className={cx(className, { checked: isActive })}>
    <StyledDiv className={cx({ checked: isActive })} />
  </StyledRadioButton>
);

export default RadioButton;
